var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphone2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Wire--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--wire--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.94,467.1c-15.29,0-30.14-7.63-48.21-18.06-5-2.89-46.31-26.53-80.09-45.85a24,24,0,0,1-12.07-20.81V369.72a1.79,1.79,0,0,1,3.57,0v12.66a20.43,20.43,0,0,0,10.27,17.71c33.78,19.33,75.1,43,80.1,45.86,27.63,15.95,46.16,24.61,70.61,10.5,8.48-4.9,12.39-10.14,11.31-15.15-.79-3.63-4.1-6.88-8.32-9.21a10,10,0,0,1-.25,6.75c-3.45,8.61-19.44,12.67-29.31,9.53-7-2.24-10.88-7.08-9.8-12.31,1.35-6.56,10.79-12.83,28.34-11.11.46,0,.92.1,1.39.17a74.73,74.73,0,0,0-15-9.24c-24.65-12-41.2-19.48-50.75-23.63-2.76-1.19-4.41-3.16-4.54-5.39s1.14-4,3.44-5.37l68-39.26c5.54-3.2,18.25,0,20.86,4.21.94,1.53,1,3.78-1.62,5.51-5.25,3.45-38.9,23.15-58.49,34.59a1.56,1.56,0,0,0-.39.3,1.49,1.49,0,0,0,.41.32,5.37,5.37,0,0,0,4.68,0l53.37-31.64a15.4,15.4,0,0,1,13.27-.54c6.43,2.91,19,8.76,42.25,20.11,10.54,5.14,16.69,9.86,20,14,7.51,2.53,14.21,7.43,15.55,13.61,1,4.58-.59,11.63-13.77,19.24l-15.93,9.2a1.78,1.78,0,0,1-1.78-3.09l15.93-9.2c9-5.17,13.13-10.49,12.07-15.4-.8-3.69-4.51-7-9.18-9.29a10,10,0,0,1-.15,7.08c-3.45,8.61-19.43,12.67-29.3,9.53-7-2.24-10.88-7.08-9.8-12.31,1.35-6.56,10.79-12.83,28.33-11.11.46,0,.92.1,1.39.16a74.18,74.18,0,0,0-15-9.23c-23.24-11.32-35.75-17.16-42.16-20.06a11.92,11.92,0,0,0-10,.35l-53.37,31.64a8.93,8.93,0,0,1-8.29,0,4,4,0,0,1-2.22-3.4,4,4,0,0,1,2.19-3.39c33.78-19.72,54.49-32,58.33-34.49.53-.35.62-.57.62-.57s-.6-1-2.73-1.94c-4-1.86-10.62-2.74-13.39-1.14l-68,39.26c-1.09.63-1.7,1.39-1.66,2.08s1,1.7,2.4,2.32c9.58,4.17,26.19,11.66,50.89,23.7,10.67,5.2,16.84,10,20.15,14.16,7.08,2.59,13.35,7.5,14.69,13.71,1,4.65-.43,11.72-13,19C297.72,464.84,289.27,467.1,280.94,467.1Zm10.47-38.88c-11.46,0-18.24,4-19.17,8.56-.7,3.38,2.14,6.52,7.39,8.19,8.13,2.59,22.2-.69,24.92-7.46.93-2.32.37-4.91-1.56-7.65a28.52,28.52,0,0,0-6.25-1.37C294.86,428.31,293.08,428.22,291.41,428.22Zm88.93-37.6c-11.45,0-18.23,4-19.16,8.56-.7,3.38,2.13,6.52,7.39,8.19,8.13,2.59,22.2-.69,24.92-7.46.94-2.35.35-5-1.64-7.76a31.9,31.9,0,0,0-6.17-1.26Q382.86,390.62,380.34,390.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plug--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.52,422.93a1.78,1.78,0,0,1,1.78.18,5.57,5.57,0,0,1,2.52,4.36,1.77,1.77,0,0,1-.75,1.64L377,434.92l-3.55-6.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,425.94a4.77,4.77,0,0,1,.3,1.53,1.77,1.77,0,0,1-.75,1.64L377,434.92l-1.26-2.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.75,433.29a5.56,5.56,0,0,0-2.52-4.36,1.79,1.79,0,0,0-1.77-.19,1.77,1.77,0,0,0-.75,1.64,5.56,5.56,0,0,0,2.52,4.36,1.53,1.53,0,0,0,2.52-1.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.85,424.86a2.34,2.34,0,0,1,2.36.23,7.38,7.38,0,0,1,3.34,5.79,2.33,2.33,0,0,1-1,2.17l-13.35,7.7-4.7-8.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,428.85a6,6,0,0,1,.4,2,2.33,2.33,0,0,1-1,2.17l-13.35,7.7-1.66-2.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.19,438.59a7.35,7.35,0,0,0-3.34-5.78,2,2,0,0,0-3.34,1.92,7.41,7.41,0,0,0,3.34,5.79,2,2,0,0,0,3.34-1.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.85,434.47a1.31,1.31,0,0,0-1.33-.13l-13.08,8.32-4.17,1.63,2.67,4.65,3.51-2.79L368.19,439a1.31,1.31,0,0,0,.56-1.22A4.21,4.21,0,0,0,366.85,434.47Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.85,434.47a1.31,1.31,0,0,0-1.33-.13l-13.08,8.32-4.17,1.63,2.67,4.65,3.51-2.79L368.19,439a1.31,1.31,0,0,0,.56-1.22A4.21,4.21,0,0,0,366.85,434.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,444.43a1.34,1.34,0,0,0-1.33-.14l-.17.14h0L347,445.48l2.3,4,1.44-.43h0a.94.94,0,0,0,.23-.1,1.32,1.32,0,0,0,.56-1.23A4.2,4.2,0,0,0,349.6,444.43Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,444.43a1.34,1.34,0,0,0-1.33-.14l-.17.14h0L347,445.48l2.3,4,1.44-.43h0a.94.94,0,0,0,.23-.1,1.32,1.32,0,0,0,.56-1.23A4.2,4.2,0,0,0,349.6,444.43Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.93,448.33a3.65,3.65,0,0,0-1.65-2.85,1,1,0,0,0-1.64.95,3.65,3.65,0,0,0,1.64,2.85,1,1,0,0,0,1.65-.95Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.44,442.66a1,1,0,0,1,1,.1,3.16,3.16,0,0,1,1.42,2.46,1,1,0,0,1-.41.93l.52-.27a1.07,1.07,0,0,0,.41-.95,3.16,3.16,0,0,0-1.43-2.47,1.08,1.08,0,0,0-1-.12Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,440.4a1.08,1.08,0,0,1,1.08.11,3.43,3.43,0,0,1,1.55,2.69,1.1,1.1,0,0,1-.44,1l.56-.3a1.15,1.15,0,0,0,.45-1,3.44,3.44,0,0,0-1.55-2.68,1.16,1.16,0,0,0-1.11-.14Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.54,438.14a1.18,1.18,0,0,1,1.17.12,3.72,3.72,0,0,1,1.68,2.91,1.19,1.19,0,0,1-.48,1.09l.61-.32a1.25,1.25,0,0,0,.48-1.12,3.72,3.72,0,0,0-1.68-2.91,1.25,1.25,0,0,0-1.2-.14Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.09,435.88a1.28,1.28,0,0,1,1.26.13,4,4,0,0,1,1.81,3.13,1.28,1.28,0,0,1-.53,1.18l.67-.35a1.33,1.33,0,0,0,.51-1.2,4,4,0,0,0-1.8-3.13,1.35,1.35,0,0,0-1.3-.16Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.44,442.66a1,1,0,0,1,1,.1,3.16,3.16,0,0,1,1.42,2.46,1,1,0,0,1-.41.93l.52-.27a1.07,1.07,0,0,0,.41-.95,3.16,3.16,0,0,0-1.43-2.47,1.08,1.08,0,0,0-1-.12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356,440.4a1.08,1.08,0,0,1,1.08.11,3.43,3.43,0,0,1,1.55,2.69,1.1,1.1,0,0,1-.44,1l.56-.3a1.15,1.15,0,0,0,.45-1,3.44,3.44,0,0,0-1.55-2.68,1.16,1.16,0,0,0-1.11-.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.54,438.14a1.18,1.18,0,0,1,1.17.12,3.72,3.72,0,0,1,1.68,2.91,1.19,1.19,0,0,1-.48,1.09l.61-.32a1.25,1.25,0,0,0,.48-1.12,3.72,3.72,0,0,0-1.68-2.91,1.25,1.25,0,0,0-1.2-.14Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M363.09,435.88a1.28,1.28,0,0,1,1.26.13,4,4,0,0,1,1.81,3.13,1.28,1.28,0,0,1-.53,1.18l.67-.35a1.33,1.33,0,0,0,.51-1.2,4,4,0,0,0-1.8-3.13,1.35,1.35,0,0,0-1.3-.16Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Headphones--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--headphones--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.11,189.8c-.37.15-.74.29-1.09.47s-.57.3-.84.45-.68.39-1,.6-.53.37-.79.57-.61.48-.91.74-.48.43-.71.66-.56.57-.83.87-.43.51-.64.77-.5.66-.74,1-.37.54-.54.82l-.12.2c-.19.32-.37.65-.54,1-.06.1-.11.2-.16.3-.14.27-.28.55-.4.83s-.22.5-.32.75-.14.31-.2.48l-.18.45c-.12.32-.23.65-.33,1s-.19.58-.27.87c-.15.53-.3,1.07-.42,1.63q-.14.56-.24,1.14c0,.21-.08.41-.12.63s-.08.45-.11.69c-.09.56-.15,1.15-.21,1.74,0,.28-.07.55-.09.83,0,.11,0,.21,0,.32-.07,1-.11,1.94-.11,2.95a54.35,54.35,0,0,0,1.45,12.09C229.37,241,240,257.9,253,267.57a48.68,48.68,0,0,0,4.76,3.18l.68.37c.38.21.76.43,1.14.62l.87.43.94.45.95.41.83.34c.33.13.65.25,1,.36l.79.27.95.3.84.22.86.22,1.14.22.53.1.45.05,6.82-3.92a33.43,33.43,0,0,1-11.95-4.37C246,256.1,231,230,231,208.6c0-8.69,2.48-15.27,6.66-19.33l-.66.19C236.69,189.56,236.4,189.68,236.11,189.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,182.56a18.37,18.37,0,0,0-3,1.36l-6.79,3.92s0,0,0,0a20.46,20.46,0,0,1,9.79-2.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.29,275.06l-.53-.1-1.14-.22-.86-.22-.56-.14-.28-.08L265,274l-.79-.27-1-.36-.83-.34-.95-.41-.94-.45-.87-.43c-.38-.19-.77-.41-1.16-.63-.21-.12-.43-.22-.65-.35a50.27,50.27,0,0,1-4.6-3.06,65.66,65.66,0,0,1-11.43-10.88A81.14,81.14,0,0,1,234,245.66,76.71,76.71,0,0,1,225.69,225l-.06-.34a54.32,54.32,0,0,1-1.45-12.07c0-.94,0-1.85.1-2.75,0-.13,0-.26,0-.39a2.45,2.45,0,0,1,0-.27c.06-.75.14-1.49.25-2.21l.06-.46c0-.24.09-.46.13-.7s.13-.66.2-1,.14-.7.22-1,.2-.72.31-1.08c0-.14.07-.28.11-.41s0-.11.05-.16c.09-.29.18-.59.28-.88s.26-.68.4-1,.34-.87.54-1.29.29-.58.44-.87l.18-.34c.16-.3.33-.59.5-.88s.33-.51.5-.76l.23-.33c.12-.19.25-.37.38-.54l.31-.39c.09-.11.17-.23.27-.34l.55-.63.19-.19c.23-.24.46-.48.71-.71h0c.11-.1.24-.19.35-.28.3-.26.6-.51.91-.74s.52-.39.79-.57.66-.41,1-.6.55-.31.84-.45.72-.32,1.09-.47.58-.24.88-.34.45-.14.68-.21l.51-.13c.3-.07.6-.16.91-.22s.88-.14,1.32-.19.59-.09.9-.11.54,0,.82,0v-3.36a20.46,20.46,0,0,0-9.79,2.65h0c-.42.25-.83.51-1.24.79l-.21.14a20.1,20.1,0,0,0-3.21,2.85l-.33.36c-.29.33-.57.67-.85,1l-.24.35a22.52,22.52,0,0,0-1.29,1.94c-.14.25-.29.5-.43.76s-.35.66-.52,1-.32.69-.48,1-.3.7-.44,1.06c-.22.56-.42,1.14-.61,1.73-.08.28-.17.57-.25.86-.14.5-.27,1-.4,1.53-.06.26-.12.51-.17.77q-.25,1.14-.42,2.34c0,.2-.05.4-.07.59-.09.68-.16,1.36-.21,2,0,.25,0,.5-.05.75-.06.89-.09,1.79-.09,2.71A61,61,0,0,0,223.6,230a80.8,80.8,0,0,0,3.26,8.81q1,2.18,2,4.31a87.13,87.13,0,0,0,7.51,12.21c5.63,7.65,12.42,14.14,19.72,18.35a39.22,39.22,0,0,0,9.25,4l4.36-2.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.51,241.11c0-19.56-13.73-43.34-30.67-53.12-8.5-4.9-16.18-5.35-21.73-2.12-1.69,1-13,7.51-14.73,8.48-5.58,3.19-9,10.07-9,19.88,0,19.56,13.73,43.34,30.67,53.12,8.48,4.9,16.16,5.35,21.71,2.13,1.7-1,13.1-7.54,14.81-8.53C300.08,257.75,303.51,250.88,303.51,241.11Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.51,241.11c0-19.56-13.73-43.34-30.67-53.12-8.5-4.9-16.18-5.35-21.73-2.12-1.69,1-13,7.51-14.73,8.48-5.58,3.19-9,10.07-9,19.88,0,19.56,13.73,43.34,30.67,53.12,8.48,4.9,16.16,5.35,21.71,2.13,1.7-1,13.1-7.54,14.81-8.53C300.08,257.75,303.51,250.88,303.51,241.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,196.52c16.93,9.78,30.66,33.57,30.66,53.12S275,277.13,258,267.35s-30.67-33.56-30.67-53.12S241.08,186.74,258,196.52Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,275.26h.15c.52,0,1,.06,1.54.07h.25a17.57,17.57,0,0,0,2.2-.13h.08a17.24,17.24,0,0,0,1.82-.34c.25-.05.51-.11.76-.18.47-.13.94-.28,1.4-.45s.69-.28,1-.44c.17-.07.32-.15.48-.23a16.2,16.2,0,0,0,4-2.86,19.72,19.72,0,0,1-8.18.49l-6.82,3.92C270.16,275.17,270.58,275.23,271,275.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.29,190.72a10.71,10.71,0,0,0,3.18,6.93c14.61,13.43,25.29,35.23,25.29,53.7,0,13.44-5.64,23-14.86,26.21h0a16.34,16.34,0,0,0,3.37-1.54l6.79-3.92c7.22-4.16,11.52-13,11.52-24.69,0-18.46-10.69-40.27-25.3-53.69a10.78,10.78,0,0,1-3.18-6.93V159.58l-6.81,3.94-3.36-1.94,3.36,1.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,197.65a10.71,10.71,0,0,1-3.18-6.93v-27.2l-3.36-1.94v30.77a6.62,6.62,0,0,0,.14,1.22l.06.3a10,10,0,0,0,.37,1.26,12,12,0,0,0,.89,1.84l.28.41a8.72,8.72,0,0,0,.88,1.17,6.44,6.44,0,0,0,.64.64h0c.81.71,1.6,1.45,2.38,2.2l.62.61c.68.68,1.35,1.37,2,2.09l.3.31c.74.81,1.46,1.64,2.18,2.5l.54.66c.59.72,1.17,1.46,1.73,2.2l.41.54c.67.89,1.32,1.81,1.95,2.73l.44.67c.52.77,1,1.56,1.51,2.35l.42.68c.59,1,1.15,1.94,1.7,2.93l.31.59c.45.83.89,1.67,1.31,2.52l.39.79q.74,1.51,1.41,3.06c.05.14.11.27.16.41.39.91.76,1.83,1.12,2.76.1.28.21.55.31.83.39,1,.76,2.11,1.09,3.16s.64,2.12.92,3.18l.18.68c.26,1,.5,2.06.71,3.09l.09.52q.28,1.42.48,2.82c0,.17.05.35.08.52.13,1,.24,2,.31,3,0,.22,0,.44.05.66.06,1,.11,2.06.11,3.07,0,6-1.19,11-3.32,14.91a19.36,19.36,0,0,1-1.55,2.4c-.28.37-.57.73-.87,1.07s-.61.66-.93,1a16.2,16.2,0,0,1-4,2.86c-.15.08-.31.16-.48.23-.33.16-.67.31-1,.44s-.86.3-1.29.42l-.11,0c-.25.07-.5.13-.76.18l-.45.12c-.45.09-.91.16-1.37.22h-.08a17.57,17.57,0,0,1-2.2.13h-.57c-.4,0-.81,0-1.22-.07H271c-.42,0-.84-.08-1.27-.14l-4.36,2.5a27.6,27.6,0,0,0,7.44,1.08c.34,0,.67,0,1-.05s.91,0,1.33-.07l.77-.11c.49-.07,1-.14,1.43-.23.23,0,.46-.1.69-.16l.28-.08c.43-.11.86-.21,1.28-.35l.3-.09c9.22-3.18,14.86-12.77,14.86-26.21C294.76,232.88,284.08,211.08,269.47,197.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,189.24l.14-.06a1,1,0,0,0,.23-.12l6.82-3.94a2.89,2.89,0,0,0,1.33-2.64V151.71l-6.81,3.94v30.77A2.81,2.81,0,0,1,251,189.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.78,185.18a27.29,27.29,0,0,1,4.88.46,1.3,1.3,0,0,0,1.64-1.32v-3.06a21.84,21.84,0,0,0-7.17,1.3v2.66C242.35,185.21,242.56,185.18,242.78,185.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.64,188.56a22.66,22.66,0,0,1,2.42.22c.78.12,1.58.28,2.38.48l.15,0,.08,0h0a5.52,5.52,0,0,0,.78.13h.07a3.48,3.48,0,0,0,.65,0h.12a3.76,3.76,0,0,0,.6-.15l0,0a2.81,2.81,0,0,0,1.71-2.82V155.65h0l-3.36-2v30.62a1.3,1.3,0,0,1-1.64,1.32,27.29,27.29,0,0,0-4.88-.46c-.22,0-.43,0-.65,0v3.36c.24,0,.47,0,.71,0S243.37,188.55,243.64,188.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,259.71c0-28.9-20.29-64-45.32-78.49-12.5-7.22-23.81-7.9-32-3.18l-13.69,7.9c-8.18,4.74-13.25,14.87-13.25,29.31,0,28.9,20.29,64,45.31,78.49,12.5,7.21,23.81,7.9,32,3.18L287.1,289C295.3,284.29,300.37,274.15,300.37,259.71Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.42,
    cy: 241.41,
    rx: 37,
    ry: 64.09,
    transform: "translate(-88.36 153.05) rotate(-30)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.76,267.58c0-28.9-20.29-64-45.32-78.49-12.52-7.23-23.85-7.9-32.05-3.15l-6.78,3.91c-8.22,4.73-13.3,14.88-13.3,29.34,0,28.9,20.29,64,45.31,78.49,12.52,7.22,23.85,7.9,32.05,3.16l6.82-3.94C281.68,292.17,286.76,282,286.76,267.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,193c25,14.45,45.32,49.59,45.32,78.49s-20.29,40.61-45.32,26.16-45.31-49.59-45.31-78.49S209.6,178.58,234.62,193Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.27,271.52c0-29.92-21.08-66.43-47-81.39-7.63-4.41-15-6.64-21.92-6.64a26.44,26.44,0,0,0-13.5,3.49c-2.26,1.32-11.4,6.55-13.72,7.9-9.3,5.45-14.84,16.91-14.84,32.19,0,29.92,21.08,66.43,47,81.39,7.63,4.41,15,6.64,21.92,6.64a26.42,26.42,0,0,0,13.58-3.54c2.22-1.31,11.25-6.47,13.55-7.8C277.7,298.33,283.27,286.85,283.27,271.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.21,315.1c-6.91,0-14.29-2.23-21.92-6.64-25.91-15-47-51.47-47-81.39,0-21.7,11.16-35.71,28.43-35.71,6.92,0,14.29,2.23,21.92,6.64,25.91,15,47,51.47,47,81.39C269.64,301.08,258.48,315.1,241.21,315.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,284.13a22.1,22.1,0,0,1-11-3.32c-12.94-7.47-23.47-25.7-23.47-40.65,0-10.83,5.58-17.83,14.2-17.83a22.15,22.15,0,0,1,10.95,3.31c12.94,7.48,23.47,25.71,23.47,40.66C245.28,277.13,239.7,284.13,231.08,284.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.28,335c0-29.92-21.08-66.43-47-81.4-7.63-4.4-15-6.63-21.91-6.63a26.39,26.39,0,0,0-13.5,3.49c-2.26,1.32-11.41,6.55-13.72,7.9-9.31,5.45-14.85,16.91-14.85,32.18,0,29.92,21.08,66.44,47,81.4,7.63,4.41,15,6.64,21.91,6.64A26.39,26.39,0,0,0,144.8,375c2.23-1.31,11.26-6.47,13.55-7.8C167.71,361.81,173.28,350.33,173.28,335Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.22,378.58c-6.91,0-14.28-2.23-21.91-6.64-25.92-15-47-51.48-47-81.4,0-21.69,11.16-35.7,28.44-35.7,6.91,0,14.28,2.23,21.91,6.63,25.91,15,47,51.48,47,81.4C159.65,364.56,148.49,378.58,131.22,378.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,342.87c0-28.9-20.29-64-45.32-78.49-12.52-7.23-23.85-7.91-32-3.16l-6.78,3.92c-8.21,4.73-13.3,14.87-13.3,29.33,0,28.9,20.29,64,45.32,78.49,12.52,7.23,23.84,7.9,32,3.17l6.82-3.94C151.23,367.45,156.3,357.31,156.3,342.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.17,268.31c25,14.45,45.32,49.59,45.32,78.49S129.2,387.41,104.17,373s-45.32-49.59-45.32-78.49S79.14,253.86,104.17,268.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.49,346.8c0-28.9-20.29-64-45.32-78.49-12.5-7.22-23.81-7.9-32-3.18L58.48,273c-8.19,4.74-13.26,14.88-13.26,29.31,0,28.9,20.29,64,45.32,78.49,12.49,7.22,23.8,7.9,32,3.18l13.67-7.89C144.41,371.39,149.49,361.25,149.49,346.8Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.54,276.18c25,14.45,45.31,49.59,45.31,78.49s-20.28,40.61-45.31,26.16-45.32-49.59-45.32-78.49S65.51,261.73,90.54,276.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,292.63c-.37.14-.74.29-1.1.46s-.56.3-.83.46-.68.39-1,.6-.53.37-.79.57-.61.47-.91.73l-.72.67c-.28.28-.55.57-.82.87s-.44.51-.65.77-.49.66-.73,1-.37.55-.54.83l-.12.2c-.19.32-.37.64-.55,1l-.15.3c-.14.27-.28.54-.41.82s-.21.5-.31.75-.14.32-.2.48l-.18.46c-.12.32-.23.65-.34,1s-.18.58-.26.87q-.24.79-.42,1.62c-.09.38-.17.76-.24,1.15l-.12.62c0,.23-.08.46-.11.69-.09.57-.15,1.15-.21,1.74,0,.28-.07.55-.09.84,0,.1,0,.21,0,.32-.07.95-.11,1.93-.11,2.95a54.35,54.35,0,0,0,1.45,12.09c3.74,16.38,14.38,33.28,27.4,42.95a52.56,52.56,0,0,0,4.76,3.18l.68.37,1.14.62.87.43.94.44c.32.15.63.28,1,.41s.55.24.83.34l1,.37.78.27,1,.29.84.23.86.21c.38.09.76.16,1.14.23l.52.1.45.05L98.42,374a33.24,33.24,0,0,1-12-4.37c-18.57-10.72-33.62-36.77-33.62-58.22,0-8.68,2.48-15.26,6.66-19.32-.22.06-.45.11-.66.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,285.39a19.22,19.22,0,0,0-3,1.35l-6.79,3.92a.06.06,0,0,0,0,0A20.46,20.46,0,0,1,64,288.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.14,377.89l-.52-.1c-.38-.07-.75-.14-1.14-.23s-.57-.14-.86-.21l-.57-.14-.27-.09-1-.29-.8-.27-1-.37c-.28-.1-.55-.22-.83-.34l-1-.4-.94-.45-.87-.43-1.16-.63-.65-.35a52.42,52.42,0,0,1-4.6-3.06,65.66,65.66,0,0,1-11.43-10.88,80.88,80.88,0,0,1-7.74-11.16,76.77,76.77,0,0,1-8.34-20.72c0-.11,0-.22-.07-.34A54.73,54.73,0,0,1,46,315.37c0-.94,0-1.85.1-2.75,0-.13,0-.27,0-.4a2.65,2.65,0,0,1,0-.27c.06-.75.14-1.48.25-2.2l.06-.46c0-.24.09-.47.13-.7s.13-.66.19-1,.14-.7.23-1,.2-.73.3-1.09l.12-.4a.94.94,0,0,0,0-.16c.1-.3.19-.59.29-.88s.26-.69.39-1,.35-.87.55-1.28.29-.58.44-.87l.18-.35c.16-.29.33-.59.5-.87s.33-.51.5-.76l.22-.34L51,298l.3-.38c.1-.11.18-.23.28-.34s.36-.42.55-.63l.18-.19.71-.71h0c.11-.1.24-.18.35-.28.3-.26.6-.5.91-.73s.52-.39.79-.57.66-.41,1-.6.55-.32.83-.46.73-.32,1.1-.46l.88-.35.68-.2L60,292c.3-.08.6-.16.91-.22s.87-.14,1.32-.19c.3,0,.59-.09.9-.12s.54,0,.82,0v-3.36a20.46,20.46,0,0,0-9.79,2.65h0c-.43.24-.84.51-1.24.78l-.21.15a20.11,20.11,0,0,0-3.22,2.85l-.32.36c-.29.33-.57.67-.85,1-.08.11-.16.23-.25.34-.45.62-.88,1.27-1.28,2l-.43.75c-.18.33-.35.67-.52,1s-.32.69-.48,1.05-.3.69-.44,1.06c-.22.56-.42,1.13-.61,1.72-.09.28-.17.57-.25.86-.14.51-.28,1-.4,1.54l-.18.77c-.16.76-.3,1.54-.41,2.34,0,.19,0,.4-.07.59-.09.67-.16,1.35-.21,2l-.06.75c-.05.89-.09,1.79-.09,2.71a60.72,60.72,0,0,0,2.78,17.45,80.64,80.64,0,0,0,3.26,8.8q.95,2.17,2,4.31a86,86,0,0,0,7.51,12.21c5.63,7.65,12.42,14.14,19.72,18.36a40.07,40.07,0,0,0,9.25,4l4.36-2.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,346.21c0-19.55-13.73-43.34-30.67-53.12-8.5-4.9-16.18-5.35-21.73-2.11l-14.73,8.47c-5.58,3.19-9,10.08-9,19.88,0,19.56,13.73,43.34,30.67,53.12,8.48,4.9,16.16,5.36,21.71,2.13l14.81-8.52C117.78,362.85,121.21,356,121.21,346.21Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.21,346.21c0-19.55-13.73-43.34-30.67-53.12-8.5-4.9-16.18-5.35-21.73-2.11l-14.73,8.47c-5.58,3.19-9,10.08-9,19.88,0,19.56,13.73,43.34,30.67,53.12,8.48,4.9,16.16,5.36,21.71,2.13l14.81-8.52C117.78,362.85,121.21,356,121.21,346.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.72,
    cy: 337.04,
    rx: 25.04,
    ry: 43.37,
    transform: "translate(-158.38 83.01) rotate(-30)",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.52,
    cy: 337.79,
    rx: 19.43,
    ry: 33.66,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, -158.91, 82.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.54,324.33,73.46,338.39,56.65,309.26c4.29-2.5,10.25-2.14,16.81,1.65A46.56,46.56,0,0,1,87.54,324.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.27,352.15c0,7.58-2.67,12.92-7,15.38L73.46,338.39l14.08-14.06C93.43,332.74,97.27,343,97.27,352.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.29,367.53C86,370,80,369.68,73.46,365.89A45.77,45.77,0,0,1,59.4,352.45l14.06-14.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,338.39,59.4,352.45c-5.91-8.4-9.73-18.69-9.73-27.78,0-7.6,2.67-12.92,7-15.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,378.09H93c.52,0,1,.06,1.54.06h.25c.75,0,1.48-.05,2.2-.13h.08a15.76,15.76,0,0,0,1.82-.33c.25-.06.51-.11.76-.18.47-.13.94-.29,1.39-.46s.7-.28,1-.43l.48-.24a15.91,15.91,0,0,0,4-2.85,19.73,19.73,0,0,1-8.18.48l-6.83,3.93C92,378,92.44,378.06,92.86,378.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.15,293.55a10.73,10.73,0,0,0,3.18,6.93c14.6,13.42,25.29,35.23,25.29,53.69,0,13.45-5.64,23-14.86,26.21h0a16,16,0,0,0,3.37-1.53l6.79-3.92c7.22-4.16,11.52-13,11.52-24.69,0-18.46-10.69-40.27-25.3-53.69A10.75,10.75,0,0,1,95,289.62V262.41l-6.81,3.94-3.36-1.94,3.36,1.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.33,300.48a10.73,10.73,0,0,1-3.18-6.93v-27.2l-3.36-1.94v30.77a6.52,6.52,0,0,0,.14,1.21l.06.31a10,10,0,0,0,.37,1.26,11.45,11.45,0,0,0,.89,1.83c.09.15.18.28.28.42a9.6,9.6,0,0,0,.87,1.17,7.81,7.81,0,0,0,.65.64h0c.81.7,1.6,1.44,2.38,2.2l.62.61c.68.68,1.35,1.37,2,2.08l.3.32c.74.81,1.46,1.64,2.17,2.49.19.22.37.45.55.67.59.72,1.17,1.45,1.73,2.2.14.18.28.35.41.53.67.9,1.31,1.81,2,2.74l.44.67c.52.77,1,1.55,1.51,2.34l.42.69c.59,1,1.15,1.94,1.7,2.92l.31.6c.45.83.89,1.67,1.31,2.52l.39.78c.49,1,1,2,1.4,3.07.06.13.12.27.17.4q.59,1.38,1.11,2.76c.11.28.22.56.32.84.38,1.05.76,2.1,1.09,3.16s.63,2.12.92,3.18c.06.22.12.45.17.68q.41,1.54.72,3.09l.09.52c.19.94.34,1.88.48,2.82,0,.17,0,.34.07.51.14,1,.24,2,.32,3,0,.22,0,.44,0,.66.06,1,.11,2.05.11,3.06,0,6-1.19,11.05-3.32,14.92a19.36,19.36,0,0,1-1.55,2.4c-.28.37-.57.73-.87,1.07s-.61.66-.93,1a15.91,15.91,0,0,1-4,2.85l-.48.24c-.34.15-.68.3-1,.43s-.85.31-1.28.43l-.11,0c-.25.07-.51.12-.76.18l-.45.11c-.45.09-.91.17-1.37.22H97a19.85,19.85,0,0,1-2.2.13h-.57c-.4,0-.81,0-1.22-.07h-.15c-.42,0-.85-.09-1.27-.15l-4.36,2.51a27.55,27.55,0,0,0,7.44,1.08c.34,0,.67,0,1,0s.91,0,1.33-.07l.77-.11c.49-.07,1-.14,1.42-.23l.7-.16.28-.08c.43-.11.86-.22,1.28-.35l.3-.1c9.22-3.17,14.86-12.76,14.86-26.21C116.62,335.71,105.93,313.9,91.33,300.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,292.07,73,292l.23-.12L80,288a2.89,2.89,0,0,0,1.33-2.64V254.54l-6.81,3.94v30.76A2.81,2.81,0,0,1,72.8,292.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.64,288a26.4,26.4,0,0,1,4.88.46,1.31,1.31,0,0,0,1.64-1.32v-3.06a21.29,21.29,0,0,0-7.17,1.3v2.66C64.21,288,64.42,288,64.64,288Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5,291.38c.79,0,1.6.11,2.42.23a23.33,23.33,0,0,1,2.38.48.58.58,0,0,1,.14,0h.09a4.49,4.49,0,0,0,.79.13h.07a4.61,4.61,0,0,0,.65,0l.12,0a2.93,2.93,0,0,0,.6-.15h0a2.81,2.81,0,0,0,1.72-2.83V258.48h0l-3.36-2v30.63a1.31,1.31,0,0,1-1.64,1.32,26.4,26.4,0,0,0-4.88-.46c-.22,0-.43,0-.65,0v3.36l.71,0C65,291.39,65.23,291.37,65.5,291.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,239.7c-1.24-.71-2.94-.61-4.82.48A15,15,0,0,0,65,252c0,2.19.77,3.73,2,4.43l27.24,15.72,9.6-16.71Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.65,239.7c-1.24-.71-2.94-.61-4.82.48A15,15,0,0,0,65,252c0,2.19.77,3.73,2,4.43l27.24,15.72,9.6-16.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.83,247.85A12.18,12.18,0,0,0,65,252c0,2.19.77,3.73,2,4.43l27.24,15.72,3.39-5.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27,267.72a15,15,0,0,1,6.82-11.8c1.86-1.08,3.55-1.19,4.78-.5s2,2.24,2,4.43a15.08,15.08,0,0,1-6.81,11.81c-1.89,1.08-3.59,1.19-4.82.47S92.27,269.9,92.27,267.72Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.27,267.72a15,15,0,0,1,6.82-11.8c1.86-1.08,3.55-1.19,4.78-.5s2,2.24,2,4.43a15.08,15.08,0,0,1-6.81,11.81c-1.89,1.08-3.59,1.19-4.82.47S92.27,269.9,92.27,267.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.22,266a8.55,8.55,0,0,1,3.87-6.7,2.35,2.35,0,0,1,3.86,2.24,8.55,8.55,0,0,1-3.86,6.69A2.36,2.36,0,0,1,95.22,266Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.14,260.54a3.4,3.4,0,0,0-.41-1.73,3.56,3.56,0,0,0-1.64.51,8.55,8.55,0,0,0-3.87,6.7,3.51,3.51,0,0,0,.41,1.73,3.59,3.59,0,0,0,1.65-.51A8.55,8.55,0,0,0,101.14,260.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,137.4c-1.23-.71-2.94-.61-4.82.48a15.06,15.06,0,0,0-6.82,11.8c0,2.19.78,3.72,2,4.43l27.23,15.72,9.61-16.71Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.84,137.4c-1.23-.71-2.94-.61-4.82.48a15.06,15.06,0,0,0-6.82,11.8c0,2.19.78,3.72,2,4.43l27.23,15.72,9.61-16.71Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243,145.54a12.48,12.48,0,0,0-.82,4.14c0,2.19.78,3.72,2,4.43l27.23,15.72,3.4-5.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,165.42a15.08,15.08,0,0,1,6.81-11.81c1.87-1.07,3.56-1.18,4.79-.49s2,2.24,2,4.43a15,15,0,0,1-6.82,11.8c-1.88,1.09-3.58,1.19-4.82.48S269.47,167.59,269.47,165.42Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,165.42a15.08,15.08,0,0,1,6.81-11.81c1.87-1.07,3.56-1.18,4.79-.49s2,2.24,2,4.43a15,15,0,0,1-6.82,11.8c-1.88,1.09-3.58,1.19-4.82.48S269.47,167.59,269.47,165.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.42,163.72a8.55,8.55,0,0,1,3.86-6.7,2.75,2.75,0,0,1,2.72-.28,2.7,2.7,0,0,1,1.15,2.51,8.53,8.53,0,0,1-3.87,6.7,2.35,2.35,0,0,1-3.86-2.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.34,158.24a3.51,3.51,0,0,0-.41-1.73,3.59,3.59,0,0,0-1.65.51,8.56,8.56,0,0,0-3.87,6.7,3.4,3.4,0,0,0,.42,1.73,3.56,3.56,0,0,0,1.64-.51A8.56,8.56,0,0,0,278.34,158.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.81,80.6l-29.4-17a57,57,0,0,0-6.74-10.07C254.45,56.28,266.93,65.84,274.81,80.6Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.81,80.6l-29.4-17a57,57,0,0,0-6.74-10.07C254.45,56.28,266.93,65.84,274.81,80.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,153.78a134.11,134.11,0,0,0,2.31-24.11c0-54.69-38.39-76.86-85.75-49.51S100.17,174,100.17,228.69a94.8,94.8,0,0,0,2.32,21.46l-11.06,6.39a110.37,110.37,0,0,1-2-21.64c0-61.55,43.22-136.41,96.53-167.18s96.52-5.83,96.52,55.73a148.8,148.8,0,0,1-2,24l-11,6.37",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.38,153.78a135,135,0,0,0,2.3-24.12c0-36.07-16.7-58-41.67-60.89,7.81,10.42,12.29,25.29,12.29,44A135.26,135.26,0,0,1,240,136.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,60c-17.32-9-40.73-7.14-66.5,7.74C132.61,98.49,89.4,173.34,89.4,234.91a110.09,110.09,0,0,0,2,21.62L62.07,239.59A108.88,108.88,0,0,1,60,218c0-61.56,43.21-136.41,96.53-167.19,26.63-15.38,50.73-16.83,68.2-6.76C229.21,46.59,245.7,56.12,252.43,60Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.42,231.21a4.72,4.72,0,0,1-2.31-.7A10.94,10.94,0,0,1,69.17,222c0-2.28,1.18-3.75,3-3.75a4.7,4.7,0,0,1,2.31.69,11,11,0,0,1,4.94,8.56C79.41,229.73,78.23,231.21,76.42,231.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,54.09A57.13,57.13,0,0,0,229,47.31c-14.73,0-30.44,4.76-46.71,14.14-37.65,21.73-70.5,64.8-87.6,110.21l-29.38-17c17.1-45.41,50-88.48,87.6-110.21,16.27-9.38,32-14.16,46.71-14.16a56.86,56.86,0,0,1,28.73,7.34C233,40.37,250.57,50.49,256.79,54.09Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.79,54.09A57.13,57.13,0,0,0,229,47.31c-14.73,0-30.44,4.76-46.71,14.14-37.65,21.73-70.5,64.8-87.6,110.21l-29.38-17c17.1-45.41,50-88.48,87.6-110.21,16.27-9.38,32-14.16,46.71-14.16a56.86,56.86,0,0,1,28.73,7.34C233,40.37,250.57,50.49,256.79,54.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,80.59C265.38,63,249.39,52.73,229,52.73c-13.77,0-28.58,4.51-44,13.42-36.9,21.3-69.07,63.68-85.61,108.23l-4.7-2.72c17.1-45.41,49.95-88.48,87.6-110.21,16.27-9.38,32-14.14,46.71-14.14,21.46,0,38.51,10.14,49,27.75Z",
    style: {
      fill: "#A1E1FF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-6",
    d: "M401.05,64.32l-4.9,16.15a4.55,4.55,0,0,0-1.33-.69,4.42,4.42,0,1,0,2.95,5.51l4.4-14.47,15.73.58h0l-4.33,14.35a4.31,4.31,0,0,0-1.33-.69,4.42,4.42,0,1,0,2.95,5.51h0l7.23-24Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-6",
    d: "M389.23,311.77l-4.9,16.15a4.31,4.31,0,0,0-1.33-.69,4.42,4.42,0,1,0,2.95,5.51l4.4-14.47,15.73.58h0l-4.33,14.35a4.31,4.31,0,0,0-1.33-.69,4.42,4.42,0,1,0,2.95,5.51h0l7.22-24Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-6",
    d: "M358.12,121.59a7.8,7.8,0,0,1,3.17-.79,16.52,16.52,0,0,1,4.37.5,30.23,30.23,0,0,0,5.79,1,7.31,7.31,0,0,0,5.41-1.88,7.63,7.63,0,0,1-3.38-.45c-2.59-1-4.67-3.65-7-5.13-3.47-2.19-6.9-2-11.12-.94,0,3.59-.07,7.2-.11,10.8l-.09,8.47c0,.27-.13,3.85-.13,3.85a7.38,7.38,0,0,0-3.15-.78,6.06,6.06,0,1,0,6,6.11Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-6",
    d: "M456,273.12a7.76,7.76,0,0,1,3.27.12,17.14,17.14,0,0,1,4.06,1.68,30.73,30.73,0,0,0,5.29,2.57,7.32,7.32,0,0,0,5.72-.32,7.64,7.64,0,0,1-3.13-1.36c-2.21-1.65-3.47-4.8-5.3-6.87-2.72-3.07-6.06-3.85-10.42-4-1,3.46-2.06,6.9-3.09,10.35l-2.43,8.12-1.2,3.65a7.29,7.29,0,0,0-2.81-1.61A6.06,6.06,0,1,0,450,293Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-6",
    d: "M312.75,57.44a8.41,8.41,0,0,1,2.05-2.89,17.91,17.91,0,0,1,3.94-2.68,33.3,33.3,0,0,0,5.48-3.29,7.9,7.9,0,0,0,3.11-5.37,8.23,8.23,0,0,1-3.1,2c-2.81,1-6.42.29-9.38.72-4.41.65-7.11,3.22-9.82,7.09,2.55,3,5,6,7.55,9l5.93,7c.19.22,2.61,3.26,2.61,3.26A8,8,0,0,0,318,73.9a6.58,6.58,0,1,0,9.27.78Z",
    style: {
      fill: "#A1E1FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Controls--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--controls--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--play-pause--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,153.48l-26.21,15.14a1.86,1.86,0,0,0-.85,1.46v30.24a1.82,1.82,0,0,0,.85,1.45l3,1.73a1.87,1.87,0,0,0,1.68,0l26.22-15.15a1.85,1.85,0,0,0,.84-1.45V156.61a1.82,1.82,0,0,0-.85-1.45l-3-1.69A1.9,1.9,0,0,0,401,153.48Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,203V172.72a1.87,1.87,0,0,1,.84-1.46l26.22-15.14c.46-.27.84-.05.84.49V186.9a1.85,1.85,0,0,1-.84,1.45L379.52,203.5C379.06,203.76,378.68,203.55,378.68,203Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.68,203V172.72a1.87,1.87,0,0,1,.84-1.46l26.22-15.14c.46-.27.84-.05.84.49V186.9a1.85,1.85,0,0,1-.84,1.45L379.52,203.5C379.06,203.76,378.68,203.55,378.68,203Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.52,203.5a2,2,0,0,1-1.69,0l-3-1.74a1.82,1.82,0,0,1-.85-1.45V170.08a1.77,1.77,0,0,1,.27-.86l4.69,2.67a1.63,1.63,0,0,0-.25.83V203C378.68,203.5,379,203.78,379.52,203.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.57,156.46c-.07-.43-.41-.58-.83-.34l-26.22,15.14a1.79,1.79,0,0,0-.59.63l-4.69-2.67a1.6,1.6,0,0,1,.58-.6L401,153.48a1.86,1.86,0,0,1,1.69,0l3,1.69A1.83,1.83,0,0,1,406.57,156.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M402.9,173.79c0,7.62-4.63,16.48-10.35,19.78s-10.36-.2-10.36-7.83,4.64-16.48,10.36-19.78S402.9,166.16,402.9,173.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.15,176.25v8.83a1.42,1.42,0,0,1-.63,1.1l-1.7,1c-.35.2-.63,0-.63-.37V178a1.42,1.42,0,0,1,.63-1.1l1.7-1C390.86,175.69,391.15,175.85,391.15,176.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.08,172.83v8.82a1.42,1.42,0,0,1-.63,1.1l-1.7,1c-.35.2-.64,0-.64-.37v-8.82a1.4,1.4,0,0,1,.64-1.09l1.7-1C396.8,172.26,397.08,172.42,397.08,172.83Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Next--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.47,139.66l-21,12.11a1.5,1.5,0,0,0-.67,1.17v24.19a1.45,1.45,0,0,0,.68,1.16l2.41,1.39a1.49,1.49,0,0,0,1.35,0l21-12.11a1.5,1.5,0,0,0,.68-1.17V142.16a1.5,1.5,0,0,0-.68-1.16l-2.41-1.35A1.49,1.49,0,0,0,431.47,139.66Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.59,179.28V155.05a1.47,1.47,0,0,1,.67-1.16l21-12.12c.37-.21.68,0,.68.39v24.23a1.5,1.5,0,0,1-.68,1.17l-21,12.11C413.89,179.89,413.59,179.71,413.59,179.28Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.59,179.28V155.05a1.47,1.47,0,0,1,.67-1.16l21-12.12c.37-.21.68,0,.68.39v24.23a1.5,1.5,0,0,1-.68,1.17l-21,12.11C413.89,179.89,413.59,179.71,413.59,179.28Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.26,179.67a1.53,1.53,0,0,1-1.35,0l-2.41-1.39a1.45,1.45,0,0,1-.68-1.16V152.94a1.39,1.39,0,0,1,.21-.69l3.76,2.14a1.3,1.3,0,0,0-.2.66v24.23C413.59,179.68,413.86,179.9,414.26,179.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.9,142c-.06-.34-.33-.46-.67-.27l-21,12.12a1.34,1.34,0,0,0-.47.5L410,152.25a1.28,1.28,0,0,1,.47-.48l21-12.11a1.49,1.49,0,0,1,1.35,0l2.41,1.35A1.51,1.51,0,0,1,435.9,142Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M430.71,152.85v8.82a1.4,1.4,0,0,1-.63,1.1l-1.7,1c-.35.2-.64,0-.64-.36v-8.83a1.4,1.4,0,0,1,.64-1.09l1.7-1C430.43,152.28,430.71,152.44,430.71,152.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.78,159.83v8.64c0,.65.34.77.77.29l8-9.22c.43-.49.25-.88-.4-.88H420A1.17,1.17,0,0,0,418.78,159.83Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Previews--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.9,178.1l-21,12.11a1.49,1.49,0,0,0-.68,1.17v24.19a1.48,1.48,0,0,0,.68,1.16l2.41,1.39a1.49,1.49,0,0,0,1.35,0l21-12.11a1.49,1.49,0,0,0,.67-1.17V180.6a1.45,1.45,0,0,0-.68-1.16l-2.41-1.35A1.49,1.49,0,0,0,364.9,178.1Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,217.72V193.49a1.47,1.47,0,0,1,.67-1.16l21-12.12c.37-.21.67,0,.67.39v24.23a1.49,1.49,0,0,1-.67,1.17l-21,12.11C347.32,218.33,347,218.15,347,217.72Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,217.72V193.49a1.47,1.47,0,0,1,.67-1.16l21-12.12c.37-.21.67,0,.67.39v24.23a1.49,1.49,0,0,1-.67,1.17l-21,12.11C347.32,218.33,347,218.15,347,217.72Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.69,218.11a1.53,1.53,0,0,1-1.35,0l-2.41-1.39a1.48,1.48,0,0,1-.68-1.16V191.38a1.4,1.4,0,0,1,.22-.69l3.75,2.14a1.3,1.3,0,0,0-.2.66v24.23C347,218.12,347.3,218.34,347.69,218.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.33,180.48c-.05-.34-.33-.46-.67-.27l-21,12.12a1.42,1.42,0,0,0-.47.5l-3.76-2.14a1.44,1.44,0,0,1,.47-.48l21-12.11a1.49,1.49,0,0,1,1.35,0l2.41,1.35A1.51,1.51,0,0,1,369.33,180.48Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M354.85,196.87v8.82a1.39,1.39,0,0,1-.63,1.1l-1.7,1c-.35.21-.63,0-.63-.36v-8.82a1.39,1.39,0,0,1,.63-1.1l1.7-1C354.57,196.3,354.85,196.47,354.85,196.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.47,200.09v-9c0-.69-.37-.83-.83-.31l-8.52,9.63c-.46.52-.27.94.42.94h7.68A1.27,1.27,0,0,0,364.47,200.09Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--now-playing-box--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.4,184.73l-91.68,52.93a1.86,1.86,0,0,0-.84,1.46v58.45a1.84,1.84,0,0,0,.84,1.44l3,1.74a1.9,1.9,0,0,0,1.69,0l91.68-52.94a1.87,1.87,0,0,0,.84-1.46V187.86a1.82,1.82,0,0,0-.85-1.45l-3-1.69A1.86,1.86,0,0,0,434.4,184.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.94,187.7c-.07-.42-.41-.57-.83-.33l-91.68,52.94a1.73,1.73,0,0,0-.6.63l-4.69-2.68a1.67,1.67,0,0,1,.58-.6l91.68-52.94a1.9,1.9,0,0,1,1.69,0l3,1.69A1.83,1.83,0,0,1,439.94,187.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,300.25V241.77a1.86,1.86,0,0,1,.85-1.46l91.68-52.94c.46-.27.84-.05.84.49v58.48a1.87,1.87,0,0,1-.84,1.46l-91.68,52.94C347,301,346.58,300.79,346.58,300.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.43,300.74a1.93,1.93,0,0,1-1.69,0l-3-1.74a1.84,1.84,0,0,1-.84-1.44V239.12a1.75,1.75,0,0,1,.26-.86l4.69,2.68a1.74,1.74,0,0,0-.25.83v58.48C346.58,300.74,346.93,301,347.43,300.74Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M358.24,286.63a.06.06,0,0,1-.07,0,.06.06,0,0,1,0-.05v-.33l-1,.6a.07.07,0,0,1-.06,0,0,0,0,0,1,0-.05v-.35a.53.53,0,0,1,0-.17l1-1.82a.28.28,0,0,1,.05-.08l.07,0,.5-.29s.05,0,.06,0a0,0,0,0,1,0,.05v1.27l.28-.16a.06.06,0,0,1,.07,0s0,0,0,0v.36a.1.1,0,0,1,0,.07l-.07.07-.28.16v.34a.16.16,0,0,1,0,.08.12.12,0,0,1-.06.06Zm-.08-.91v-.61l-.48.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.2,284.25a.31.31,0,0,1,0,.08l-.07.06-.43.25s-.05,0-.06,0a0,0,0,0,1,0,0v-.43a.13.13,0,0,1,0-.08.09.09,0,0,1,.06-.06l.43-.26h.07a.08.08,0,0,1,0,.05Zm0,1.16a.31.31,0,0,1,0,.08l-.07.06-.43.25s-.05,0-.06,0a0,0,0,0,1,0-.05v-.43a.13.13,0,0,1,0-.08.09.09,0,0,1,.06-.06l.43-.25a.06.06,0,0,1,.07,0s0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.88,284.53s-.05,0-.07,0a.06.06,0,0,1,0-.05v-.34l-1.05.61h-.06a.05.05,0,0,1,0,0v-.35a.34.34,0,0,1,.05-.17l1-1.82.05-.08a.18.18,0,0,1,.07-.05l.5-.29s.05,0,.06,0a0,0,0,0,1,0,.05v1.27l.29-.17h.06a.05.05,0,0,1,0,.05v.35a.13.13,0,0,1,0,.08l-.06.07-.29.16v.34a.16.16,0,0,1,0,.08.12.12,0,0,1-.06.06Zm-.08-.92V283l-.48.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.41,283.56a.1.1,0,0,0,0,0l.72-2.09-1,.57a0,0,0,0,1-.06,0s0,0,0,0v-.36a.11.11,0,0,1,0-.07s0-.05.06-.07l1.59-.91a0,0,0,0,1,.06,0,0,0,0,0,1,0,.05v.3a.58.58,0,0,1-.06.2l-.72,2.09,0,.08-.06.06-.47.27h-.05A0,0,0,0,1,363.41,283.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.59,248.1a.91.91,0,0,1-.08.39,1.47,1.47,0,0,1-.21.39,2.6,2.6,0,0,1-.32.35,2.33,2.33,0,0,1-.37.27,1.48,1.48,0,0,1-.38.16.72.72,0,0,1-.32,0,.38.38,0,0,1-.22-.13.57.57,0,0,1-.08-.31.69.69,0,0,1,0-.2l.06-.19a.75.75,0,0,1,.08-.18l.08-.17.64-1.22,0-.07.07-.06.53-.3s0,0,0,0,0,0,0,0v.05l-.44.84a1.28,1.28,0,0,1,.33-.11.59.59,0,0,1,.27,0,.4.4,0,0,1,.19.15A.55.55,0,0,1,423.59,248.1Zm-1.36.79a.18.18,0,0,0,0,.11.13.13,0,0,0,.09,0,.26.26,0,0,0,.12,0l.14-.06.13-.1a.68.68,0,0,0,.12-.12,1.19,1.19,0,0,0,.09-.15.4.4,0,0,0,0-.15.18.18,0,0,0,0-.11.15.15,0,0,0-.09,0,.17.17,0,0,0-.12,0,.38.38,0,0,0-.13.06.45.45,0,0,0-.14.1.68.68,0,0,0-.12.12.6.6,0,0,0-.09.15A.4.4,0,0,0,422.23,248.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.65,247a.16.16,0,0,1,0,.08l-.06.06-.43.25s-.05,0-.07,0a.06.06,0,0,1,0-.05V247a.24.24,0,0,1,0-.08.13.13,0,0,1,.07-.06l.43-.25s.05,0,.06,0,0,0,0,0Zm0,1.16a.16.16,0,0,1,0,.08.17.17,0,0,1-.06.06l-.43.25s-.05,0-.07,0a.06.06,0,0,1,0,0v-.43a.24.24,0,0,1,0-.08.13.13,0,0,1,.07-.06l.43-.25s.05,0,.06,0,0,0,0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.89,244.67H427a.05.05,0,0,1,0,.05v.35a.24.24,0,0,1,0,.08.56.56,0,0,1,0,.08l-.4.63a.69.69,0,0,1,.42,0,.32.32,0,0,1,.17.33,1.17,1.17,0,0,1-.26.71,2.49,2.49,0,0,1-.73.61,1.6,1.6,0,0,1-.42.18.58.58,0,0,1-.31,0,.29.29,0,0,1-.19-.09.29.29,0,0,1-.07-.2.1.1,0,0,1,0-.07.12.12,0,0,1,.05-.05l.42-.24a.11.11,0,0,1,.1,0l.08,0h.12a.43.43,0,0,0,.2-.08,1.2,1.2,0,0,0,.27-.21.32.32,0,0,0,.1-.23c0-.08,0-.11-.1-.11a.83.83,0,0,0-.27.1l-.27.16s0,0-.06,0a0,0,0,0,1,0,0v-.28a.24.24,0,0,1,0-.08.56.56,0,0,1,.05-.08l.35-.56-.86.5s-.05,0-.07,0,0,0,0,0v-.35a.14.14,0,0,1,.09-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.55,243.68a1.41,1.41,0,0,1,.43-.17.54.54,0,0,1,.29,0,.37.37,0,0,1,.18.19.94.94,0,0,1,.07.3v.59a1.89,1.89,0,0,1-.07.39,1.46,1.46,0,0,1-.18.38,2,2,0,0,1-.29.37,2.4,2.4,0,0,1-.43.32,1.59,1.59,0,0,1-.43.18.48.48,0,0,1-.3,0,.42.42,0,0,1-.17-.18.94.94,0,0,1-.07-.31c0-.09,0-.18,0-.29s0-.2,0-.3a1.8,1.8,0,0,1,.07-.38,2.2,2.2,0,0,1,.17-.39,2,2,0,0,1,.3-.37A2.53,2.53,0,0,1,428.55,243.68Zm.35,1.27a5.23,5.23,0,0,0,0-.56.59.59,0,0,0,0-.14.16.16,0,0,0-.06-.08.13.13,0,0,0-.11,0,.46.46,0,0,0-.16.06.76.76,0,0,0-.17.13.61.61,0,0,0-.1.14.44.44,0,0,0-.06.16.9.9,0,0,0,0,.16,5.23,5.23,0,0,0,0,.56.58.58,0,0,0,0,.14.19.19,0,0,0,0,.09.2.2,0,0,0,.11,0,.56.56,0,0,0,.17-.07,1.11,1.11,0,0,0,.16-.12.72.72,0,0,0,.11-.15.47.47,0,0,0,.06-.15A1,1,0,0,0,428.9,245Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,277.28l48.32-27.9c.79-.46,1.43-.13,1.43.73a3.06,3.06,0,0,1-1.43,2.38l-48.32,27.9c-.79.46-1.44.13-1.44-.73A3.06,3.06,0,0,1,369.11,277.28Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,277.28l36.28-20.95c.79-.46,1.44-.13,1.44.73a3.09,3.09,0,0,1-1.44,2.38l-36.28,20.95c-.79.46-1.44.13-1.44-.73A3.06,3.06,0,0,1,369.11,277.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.91,213l-4.28,2.46c-1.76,1-4.83,2.93-6.59,2.45-1.48-.4-2.62-2.39-4.66-1.21-1.29.74-2.72,5.31-5.23,6.76s-4-2.64-4.81-4.75-2.24-6.06-5.23-4.34-4.54,7.77-6.44,12.21-4.37,8.74-7.42,10.5c-3.6,2.08-6.08,1.07-7.77,2.05s-3.11,4.08-5,5.87c-1.68,1.63-4.27,3.2-5.76,2s-2.56-4.28-4.06-3.42-2.71,5.84-4.13,8.33-3,4-7.19,6.41l-7.94,4.58v.57l3.42-2c1.71-1,4.12-2.29,5.73-1.61s1.68,1.3,3.1.48,2-2,3-3.61a8.91,8.91,0,0,1,2.75-3.11c1-.61,2.37,0,3.2.8s1.64,1.67,2.87,1a8.67,8.67,0,0,0,2.88-3.72c.8-1.56,1.24-2.79,2.12-3.31a4.56,4.56,0,0,1,3.1-.26,6.86,6.86,0,0,0,4.81-1c2.08-1.2,4.5-3.32,7.54-8.74l4.61-2.67c3.36-1.93,5.68-3.06,7.22-2.7,1.92.44,4.56,4.14,7.43,2.47s3.71-6,5.13-8.86a12.22,12.22,0,0,1,5.82-6.25l11.74-6.78Z",
    style: {
      fill: "#A1E1FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.34,235.63c-1.73-.66-3.3-2.34-4.55-2.63-1.54-.36-3.86.77-7.22,2.7L394,238.37c2.66-4.77,5.19-12.24,6.14-15.2.41-1.26.87-2.52,1.41-3.75a16.37,16.37,0,0,1,2.12-3.71c1.49-1.55,2.61-1.72,3.33.08s.19,7.16.32,11.71S408.65,234.61,410.34,235.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.75,247c1.49,1.18,4.08-.39,5.76-2,1.86-1.79,3.27-4.89,5-5.87s4.17,0,7.77-2.05a11.24,11.24,0,0,0,3.06-2.77h0c-1.31,2-3.3,5.74-7.19,8.55-2.26,1.63-5.19,2.63-6.49,3.38a7.77,7.77,0,0,0-3.08,3.19h0c-.37.61-.71,1.39-1.16,2.27a8.67,8.67,0,0,1-2.88,3.72,1.58,1.58,0,0,1-1.58.09c-1.09-.85-1.58-2.71-1.72-6.63-.17-4.53-.81-5.41-1.52-5.28C370.19,242.76,371.26,245.87,372.75,247Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.28,227.5c-.13-4.55.41-9.91-.32-11.71-.49-1.22-1.16-1.53-2-1.13,1.27-.17,2.39,1.84,1.65,6.79-.41,2.74-1.62,7.88-1,11.52a1.52,1.52,0,0,1,.21,0c1.25.29,2.82,2,4.55,2.63C408.65,234.61,407.41,232.06,407.28,227.5Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,238.37l2.55-1.48a76.3,76.3,0,0,0,2.31-7.32c1-3.59,1.76-7.81,2.69-10.15-.54,1.23-1,2.49-1.41,3.75C399.15,226.13,396.62,233.6,394,238.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,218.48c-1,1.68-2.18,4-3.86,5-2.51,1.45-4-2.64-4.81-4.75-.24-.61-.53-1.39-.89-2.13,1,2.14,1.84,6.06,2.45,8.27.52,1.88,1.05,3.16,2.52,2.59s2.48-3.67,3.09-5.34A29.2,29.2,0,0,1,419,218.48Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.25,221.29c-.76,2.35-1.11,4.94-2.3,8.72.47-1.2.9-2.4,1.4-3.4a12.22,12.22,0,0,1,5.82-6.25l3.85-2.22c-3.71,2.14-5.31.5-6.2,0S420,218.94,419.25,221.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.3,218.05c-.72.14-1.44,1.34-2.05,3.24-.76,2.35-1.11,4.94-2.3,8.72.47-1.2.9-2.4,1.4-3.4.36-.73.7-1.36,1-1.94.14-1.12.23-2.1.29-2.68C419.87,220.26,420.5,218.63,421.3,218.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.25,237.1c-3.6,2.08-6.08,1.07-7.77,2.05a3.86,3.86,0,0,0-.78.61c1.14-1,3-.25,4.43,0a6.67,6.67,0,0,0,4.16-.91,49.09,49.09,0,0,0,3-4.49h0A11.24,11.24,0,0,1,391.25,237.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.21,248.9c.14,3.92.63,5.78,1.72,6.63a1.58,1.58,0,0,0,1.58-.09,7.88,7.88,0,0,0,2.66-3.29c-1.45,2-3.63,2.33-4.25.43s-.64-4.54-1.07-6.34-.92-2.73-1.62-2.77h-.14l-.1,0-.06,0-.08,0-.16.07C369.4,243.49,370,244.37,370.21,248.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.56,252c-1.43,2.49-3,4-7.19,6.41l-.92.53c5.29-3,7.36-2.26,8.73-5.15s1.91-7.73,2.6-9.09C366.68,246.47,365.68,250,364.56,252Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43,233.19a53.35,53.35,0,0,1-2.48,5.18c-3,5.42-5.45,7.54-7.53,8.74a6.77,6.77,0,0,1-4.8,1,4.64,4.64,0,0,0-3.11.27,6.92,6.92,0,0,1,4.19-1.16c1.66-.05,4.11-.78,6.93-3.58S396.31,233.42,396.43,233.19Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.86,257.45a.09.09,0,0,1,.12,0,.21.21,0,0,1,0,.15v.33a.54.54,0,0,1,0,.21.24.24,0,0,1-.12.14l-1.13.66v5.46a.54.54,0,0,1-.05.21.34.34,0,0,1-.12.14l-.25.14a.07.07,0,0,1-.11,0,.17.17,0,0,1-.05-.15v-5.46l-1.14.66a.1.1,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-.34a.49.49,0,0,1,.05-.2c0-.07.07-.12.12-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,255.16a.1.1,0,0,1,.12,0,.21.21,0,0,1,.05.15v6.05a.54.54,0,0,1-.05.21.28.28,0,0,1-.12.14l-.25.14a.07.07,0,0,1-.11,0,.21.21,0,0,1,0-.15v-2.64l-2.14,1.24v2.64a.54.54,0,0,1,0,.21.28.28,0,0,1-.12.14l-.24.14q-.08,0-.12,0a.22.22,0,0,1-.05-.16v-6a.49.49,0,0,1,.05-.2.24.24,0,0,1,.12-.14l.24-.15a.1.1,0,0,1,.12,0,.21.21,0,0,1,0,.15v2.57l2.14-1.24v-2.57a.49.49,0,0,1,0-.2.27.27,0,0,1,.11-.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.66,258.66a.09.09,0,0,1,.11,0,.17.17,0,0,1,.05.15v.34a.35.35,0,0,1-.05.2.37.37,0,0,1-.11.15l-2.46,1.42a.1.1,0,0,1-.12,0,.21.21,0,0,1-.05-.15v-6a.54.54,0,0,1,.05-.21c0-.07.07-.12.12-.14l2.41-1.39a.08.08,0,0,1,.11,0,.18.18,0,0,1,0,.15v.34a.41.41,0,0,1,0,.21.33.33,0,0,1-.11.14l-2,1.15v2l1.87-1.08a.09.09,0,0,1,.11,0,.21.21,0,0,1,.05.15v.34a.46.46,0,0,1-.05.2.37.37,0,0,1-.11.15l-1.87,1.07v2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.43,250.68a1.17,1.17,0,0,1,.65-.2,1,1,0,0,1,.49.15,1,1,0,0,1,.3.38,1.39,1.39,0,0,1,.11.47.38.38,0,0,1,0,.17.27.27,0,0,1-.1.11l-.25.15a.14.14,0,0,1-.1,0s-.06-.05-.09-.12a.85.85,0,0,0-.1-.18.45.45,0,0,0-.19-.17.49.49,0,0,0-.28-.07.78.78,0,0,0-.4.13,1.46,1.46,0,0,0-.32.25,1.54,1.54,0,0,0-.28.34,2,2,0,0,0-.2.42,1.45,1.45,0,0,0-.07.47.76.76,0,0,0,.07.37.37.37,0,0,0,.23.17,1,1,0,0,0,.39,0,5.62,5.62,0,0,0,.58-.08,2,2,0,0,1,.58,0,.76.76,0,0,1,.4.16.73.73,0,0,1,.22.35,2.45,2.45,0,0,1,.07.59,3,3,0,0,1-.12.84,4,4,0,0,1-.33.8,3.14,3.14,0,0,1-.52.68,2.61,2.61,0,0,1-.67.53,1.4,1.4,0,0,1-.65.22.84.84,0,0,1-.51-.12.91.91,0,0,1-.34-.36,1.2,1.2,0,0,1-.13-.54.32.32,0,0,1,0-.16.31.31,0,0,1,.09-.12l.25-.14a.13.13,0,0,1,.11,0s.06.05.08.12a.91.91,0,0,0,.11.22.61.61,0,0,0,.21.18.72.72,0,0,0,.31.05,1,1,0,0,0,.43-.16,1.66,1.66,0,0,0,.4-.31,1.9,1.9,0,0,0,.34-.41,1.86,1.86,0,0,0,.23-.47,1.41,1.41,0,0,0,.09-.49.53.53,0,0,0-.1-.36.43.43,0,0,0-.28-.15,1.13,1.13,0,0,0-.45,0,5.6,5.6,0,0,0-.59.1,1.5,1.5,0,0,1-.52,0,.65.65,0,0,1-.35-.2.85.85,0,0,1-.19-.38,2.34,2.34,0,0,1-.06-.56,3.23,3.23,0,0,1,.09-.73,3.47,3.47,0,0,1,.27-.74,3.21,3.21,0,0,1,.45-.66A2.66,2.66,0,0,1,393.43,250.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,251.89a5.53,5.53,0,0,1,.11-1.06,5.23,5.23,0,0,1,.33-1,4.3,4.3,0,0,1,.52-.85,2.91,2.91,0,0,1,.71-.61,1.38,1.38,0,0,1,.72-.21.84.84,0,0,1,.52.24,1.58,1.58,0,0,1,.33.62,3.63,3.63,0,0,1,.11.92c0,.55,0,1.11,0,1.67a5.47,5.47,0,0,1-.12,1.06,4.89,4.89,0,0,1-.33,1,3.59,3.59,0,0,1-.52.84,2.59,2.59,0,0,1-.71.61,1.33,1.33,0,0,1-.71.21.72.72,0,0,1-.51-.24,1.35,1.35,0,0,1-.33-.63,3.14,3.14,0,0,1-.12-.91C395.71,253,395.71,252.45,395.73,251.89Zm2.78-1.56a2.62,2.62,0,0,0-.1-.71.77.77,0,0,0-.23-.41.47.47,0,0,0-.34-.13,1.06,1.06,0,0,0-.44.14,2.42,2.42,0,0,0-.43.36,2.12,2.12,0,0,0-.34.52,3.4,3.4,0,0,0-.24.68,5.14,5.14,0,0,0-.09.82c0,.29,0,.55,0,.8s0,.5,0,.78a3.16,3.16,0,0,0,.09.71.89.89,0,0,0,.24.41.47.47,0,0,0,.34.13.89.89,0,0,0,.43-.15,1.66,1.66,0,0,0,.44-.36,2,2,0,0,0,.34-.52,2.64,2.64,0,0,0,.23-.67,4.19,4.19,0,0,0,.1-.83c0-.28,0-.55,0-.79S398.51,250.61,398.51,250.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.77,251.93c-.06,0-.1,0-.14,0a.5.5,0,0,1-.1-.14l-2-3.44V253a.54.54,0,0,1-.05.21.27.27,0,0,1-.11.14l-.25.15a.1.1,0,0,1-.12,0,.21.21,0,0,1,0-.15v-6.05a.54.54,0,0,1,0-.21.24.24,0,0,1,.12-.14l.21-.13c.06,0,.1,0,.14,0a.64.64,0,0,1,.1.13l2,3.44v-4.6a.54.54,0,0,1,.05-.21.27.27,0,0,1,.11-.14l.25-.15a.1.1,0,0,1,.12,0,.21.21,0,0,1,0,.15v6.05a.54.54,0,0,1,0,.21.24.24,0,0,1-.12.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,247.07a5.25,5.25,0,0,1,.11-1,4.61,4.61,0,0,1,.33-1,3.47,3.47,0,0,1,.54-.86,2.9,2.9,0,0,1,.76-.63,1.45,1.45,0,0,1,.72-.24.91.91,0,0,1,.53.17.94.94,0,0,1,.31.4,1.58,1.58,0,0,1,.12.51.34.34,0,0,1,0,.16.25.25,0,0,1-.1.12l-.25.14c-.09.06-.15.06-.17,0a1.91,1.91,0,0,0-.17-.32.55.55,0,0,0-.22-.21.52.52,0,0,0-.31-.05,1.11,1.11,0,0,0-.42.16,2,2,0,0,0-.46.37,2.31,2.31,0,0,0-.36.54,2.6,2.6,0,0,0-.25.68,4.08,4.08,0,0,0-.1.81c0,.28,0,.54,0,.78s0,.49,0,.77a2.79,2.79,0,0,0,.1.73.86.86,0,0,0,.25.42.47.47,0,0,0,.36.12,1.06,1.06,0,0,0,.46-.16,1.87,1.87,0,0,0,.45-.36,1.68,1.68,0,0,0,.37-.52,2.67,2.67,0,0,0,.25-.69,3.88,3.88,0,0,0,.09-.87v-.26l-.88.5a.08.08,0,0,1-.11,0,.21.21,0,0,1-.05-.15v-.33a.54.54,0,0,1,.05-.21.27.27,0,0,1,.11-.14l1.29-.75a.1.1,0,0,1,.12,0,.21.21,0,0,1,0,.15v.89a5,5,0,0,1-.12,1.1,4.61,4.61,0,0,1-.34,1,3.52,3.52,0,0,1-.54.85,2.88,2.88,0,0,1-.74.62,1.44,1.44,0,0,1-.76.24.76.76,0,0,1-.54-.24,1.44,1.44,0,0,1-.32-.63,3.7,3.7,0,0,1-.12-.94Q404,247.91,404,247.07Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphone2);
export default __webpack_public_path__ + "static/media/Headphone2.e45d805acd08e5630560674ba11d5174.svg";
export { ForwardRef as ReactComponent };